import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import { store } from '@/store';
import { i18n, lang } from '@/boot/i18n';
import isEmpty from 'lodash/isEmpty';
import { FIB } from '@/config/constants';
import { makeScreen } from "./_utils";
import { passesIndicatorRule } from '@/store/helpers/rules';
var STAFF_RENDER_TYPE = FIB.STAFF_RENDER_TYPE,
    STAFF_FOLLOWUP_TYPE = FIB.STAFF_FOLLOWUP_TYPE;
var type = 'staff';
/**
 * Get staff members in an appropriate form for the Staff Question component, ordered by weight
 * @returns {Array}
 */

function getStaffData() {
  return _getStaffData.apply(this, arguments);
}
/**
 * Get the appropriate title for the Staff Question
 * @param {Number} renderType
 * @returns {String}
 */


function _getStaffData() {
  _getStaffData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _staff$members2;

    var staff, members;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return store.dispatch('checkIn/fetchStaff');

          case 2:
            _context3.t0 = _context3.sent;

            if (_context3.t0) {
              _context3.next = 5;
              break;
            }

            _context3.t0 = [];

          case 5:
            staff = _context3.t0;
            members = staff === null || staff === void 0 ? void 0 : (_staff$members2 = staff.members) === null || _staff$members2 === void 0 ? void 0 : _staff$members2.map(function (s) {
              var _s$teamId;

              return {
                id: s.id,
                name: s.displayName || s.fullName,
                gender: s.gender || null,
                teamId: (_s$teamId = s.teamId) !== null && _s$teamId !== void 0 ? _s$teamId : null,
                type: s.type || null,
                showModal: true,
                // hardcoded false until staff selection design finalised
                avatar: s.imageUrl,
                thumb: s.thumbnailUrl
              };
            });
            return _context3.abrupt("return", {
              members: members,
              tags: staff.tags
            });

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getStaffData.apply(this, arguments);
}

function getTitle(renderType) {
  var _STAFF_RENDER_TYPE$TE;

  return lang((_STAFF_RENDER_TYPE$TE = {}, _defineProperty(_STAFF_RENDER_TYPE$TE, STAFF_RENDER_TYPE.TEXT, 'questions_staff_text_title'), _defineProperty(_STAFF_RENDER_TYPE$TE, STAFF_RENDER_TYPE.SELECT, 'questions_staff_select_title'), _STAFF_RENDER_TYPE$TE)[renderType]);
}

export default {
  type: type,
  requiresTransaction: false,

  /**
   * Determines if a Staff question should be added to the selection
   *
   * @param {Object} context
   *
   * @returns {Boolean} true if the question should be added to the selection, else false.
   */
  select: function () {
    var _select = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (passesIndicatorRule(context.survey.staffSelector.indicatorRule)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", false);

            case 2:
              return _context.abrupt("return", true);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function select(_x) {
      return _select.apply(this, arguments);
    }

    return select;
  }(),

  /**
   * Renders a Staff Screen
   *
   * @param {Object} context
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
      var _staff, _staff$members, _survey$staffSelector;

      var section, survey, staff, renderType;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              section = context.section, survey = context.survey; // Fetch staff if the configured render type requires it.

              staff = [];

              if (!(survey.staffSelector.renderType === STAFF_RENDER_TYPE.SELECT)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 5;
              return getStaffData();

            case 5:
              _context2.t0 = _context2.sent;

              if (_context2.t0) {
                _context2.next = 8;
                break;
              }

              _context2.t0 = [];

            case 8:
              staff = _context2.t0;

            case 9:
              // If it turns out that there are no staff, then we need to fall back to the TEXT type, else use the passed render type.
              renderType = !((_staff = staff) !== null && _staff !== void 0 && (_staff$members = _staff.members) !== null && _staff$members !== void 0 && _staff$members.length) ? STAFF_RENDER_TYPE.TEXT : survey.staffSelector.renderType;
              return _context2.abrupt("return", makeScreen(context, [{
                id: section.name,
                type: 'fib-staff-question',
                required: section.required,
                label: '',
                props: {
                  renderType: renderType,
                  followupType: (_survey$staffSelector = survey.staffSelector.followup) !== null && _survey$staffSelector !== void 0 ? _survey$staffSelector : STAFF_FOLLOWUP_TYPE.TAGS,
                  staff: staff.members,
                  tags: staff.tags
                }
              }], {
                title: getTitle(renderType)
              }));

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function render(_x2) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    var _context$response, _response$value, _response$value2;

    // There should only be 1 staff selector section, so let's just use the value (if any) from the first such response.
    var response = (_context$response = context.response) === null || _context$response === void 0 ? void 0 : _context$response[0];

    if (!response) {
      return null;
    } // Extract & check content


    var renderType = response === null || response === void 0 ? void 0 : (_response$value = response.value) === null || _response$value === void 0 ? void 0 : _response$value.renderType;

    if (renderType == null) {
      return null;
    } // We have to check against null here as 0 is a valid value


    var value = response === null || response === void 0 ? void 0 : (_response$value2 = response.value) === null || _response$value2 === void 0 ? void 0 : _response$value2.value; // If there's no answer (e.g. no selected staff or no text), record this as no answer against the question.

    if (isEmpty(value)) {
      return null;
    }

    return {
      renderType: renderType,
      selected: renderType === STAFF_RENDER_TYPE.SELECT ? value : null,
      description: renderType === STAFF_RENDER_TYPE.TEXT ? value : null,
      mutateSubmit: function mutateSubmit(submit) {
        var _this$selected;

        // Based on what was rendered, mutate the submission appropriately - we're only allowed to submit one or the other.
        // Description text:
        var desc = this.description;

        if (desc) {
          submit.thankStaff = {
            desc: desc
          };
        } // Selected staff members:
        // If the user was presented with staff to select from, only 1 is selectable at the moment,
        // so attempt to find this first id.


        var member = (_this$selected = this.selected) === null || _this$selected === void 0 ? void 0 : _this$selected[0];

        if (member) {
          var _ref = member || {},
              id = _ref.id,
              _ref$subQuestions = _ref.subQuestions,
              subQuestions = _ref$subQuestions === void 0 ? [] : _ref$subQuestions;

          subQuestions = subQuestions.map(function (question) {
            var answersFallback = question.question_type === 'staff_text_question' ? '' : [];
            var question_type = question.question_type,
                _question$answers = question.answers,
                answers = _question$answers === void 0 ? answersFallback : _question$answers;
            return {
              question_type: question_type,
              answers: answers
            };
          });
          submit.thankStaff = {
            id: id,
            subQuestions: subQuestions
          };
        }
      }
    };
  },
  summary: {
    weight: 95,

    /**
     * Build summary content
     * @param {Object} context context
     */
    build: function build(_ref2) {
      var _answer$selected;

      var builder = _ref2.builder;
      var answer = store.getters['answers/firstAnswerOfType'](type);

      if (!answer) {
        return;
      }

      if (answer.description) {
        builder.comments(i18n.tc('checkout.shareComment', answer.description));
      }

      var firstStaff = (_answer$selected = answer.selected) === null || _answer$selected === void 0 ? void 0 : _answer$selected[0];

      if (firstStaff) {
        // If the staff member has a thumbnail, show it, else just render the comment
        var comment = i18n.tc('checkout.shareStaffApplaud', firstStaff.name);

        if (firstStaff.thumb) {
          builder.avatar(comment, firstStaff.thumb);
        } else {
          builder.comments(comment);
        }
      }
    }
  }
};